import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function FirmSettings() {
    const [firm, setFirm] = useState({ name: '', address: '', contact: '', email: '', gst_no: '' });

    useEffect(() => {
        const fetchFirm = async () => {
            try {
                const res = await axios.get(`${getApiUrl()}/firm-settings`);
                if (res.data.name) setFirm(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchFirm();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/firm-settings`, firm);
            alert('Settings Saved');
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Firm Settings</h2>
                <form onSubmit={handleSubmit} className="card p-4">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label">Firm Name</label>
                            <input type="text" className="form-control" value={firm.name} onChange={e => setFirm({...firm, name: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">GST No</label>
                            <input type="text" className="form-control" value={firm.gst_no} onChange={e => setFirm({...firm, gst_no: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-12">
                            <label className="form-label">Address</label>
                            <textarea className="form-control" value={firm.address} onChange={e => setFirm({...firm, address: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Contact</label>
                            <input type="text" className="form-control" value={firm.contact} onChange={e => setFirm({...firm, contact: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Email</label>
                            <input type="email" className="form-control" value={firm.email} onChange={e => setFirm({...firm, email: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-12 mt-3 d-grid d-md-block">
                            <button type="submit" className="btn btn-primary btn-lg">Save Settings</button>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    );
}

export default FirmSettings;
